import apiClient, { get } from '../apiClient';
import axios from 'axios';
import { API_BASE_URL } from '../config';
const candidateService = {
  // Get candidate pipeline data
  getPipeline: async () => {
    try {
      const response = await apiClient.get('/recruitment/candidate-pipeline');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all shortlisted candidates (for interview scheduling)
  getShortlistedCandidates: async () => {
    try {
      const url = `/recruitment/candidates/shortlisted`;
                const response = await apiClient.get(url);

                if (response && response.responseCode) {
                  return response;
                }

                return {
                  responseCode: 200,
                  responseMessage: "Shortlisted candidates retrieved successfully",
                  data: response,
                };
              } catch (error) {
                return {
                  success: false,
                  responseCode: error.response?.status || 500,
                  responseMessage:
                    error.response?.data?.responseMessage ||
                    error.message ||
                    "Failed to fetch shortlisted candidates",
                  error: error.response?.data?.error || error.message,
                  data: null,
                };
              }
            },

            // Get all candidates with filtering
            getCandidates: async (params = {}) => {
              try {
                const queryParams = new URLSearchParams();
                if (params.page) queryParams.append("page", params.page);
                if (params.limit) queryParams.append("limit", params.limit);
                if (params.status) queryParams.append("status", params.status);
                if (params.jobId) queryParams.append("jobId", params.jobId);
                if (params.job) queryParams.append("job", params.job);
                if (params.department) queryParams.append("department", params.department);
                if (params.search) queryParams.append("search", params.search);
                if (params.fields) queryParams.append("fields", params.fields);
                if (params.view) queryParams.append("view", params.view);
                if (params.excludeStatus) queryParams.append("excludeStatus", params.excludeStatus);
                if (params.startDate) queryParams.append("startDate", params.startDate);
                if (params.endDate) queryParams.append("endDate", params.endDate);
                if (params.sortBy) queryParams.append("sortBy", params.sortBy);
                if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);

                const url = `/recruitment/candidates${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
                const response = await apiClient.get(url);

                if (response && response.responseCode) {
                  return response;
                }

                return {
                  responseCode: 200,
                  responseMessage: "Candidates retrieved successfully",
                  data: response,
                };
              } catch (error) {
                return {
                  success: false,
                  responseCode: error.response?.status || 500,
                  responseMessage:
                    error.response?.data?.responseMessage ||
                    error.message ||
                    "Failed to fetch candidates",
                  error: error.response?.data?.error || error.message,
                  data: null,
                };
              }
            },

            getStageCounts: async (params = {}) => {
              try {
                const queryParams = new URLSearchParams();
                if (params.jobId) queryParams.append("jobId", params.jobId);
                if (params.search) queryParams.append("search", params.search);
                if (params.startDate) queryParams.append("startDate", params.startDate);
                if (params.endDate) queryParams.append("endDate", params.endDate);

                const url = `/recruitment/candidates/stage-counts${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
                const response = await apiClient.get(url);
                return response;
              } catch (error) {
                throw error;
              }
            },

            // Get candidate by ID
            getCandidateById: async (id) => {
              try {
                const response = await apiClient.get(`/recruitment/candidates/${id}`);

                if (response && response.responseCode) {
                  return response;
                }

                return {
                  responseCode: 200,
                  responseMessage: "Candidate details retrieved successfully",
                  data: response,
                };
              } catch (error) {
                return {
                  success: false,
                  responseCode: error.response?.status || 500,
                  responseMessage:
                    error.response?.data?.responseMessage ||
                    error.message ||
                    "Failed to fetch candidate",
                  error: error.response?.data?.error || error.message,
                  data: null,
                };
              }
            },

            // Export a single candidate's full detail as a backend-generated Excel (.xlsx)
            // workbook and trigger the browser download.
            exportCandidateDetail: async (candidateId, fallbackName = 'Candidate') => {
              try {
                if (!candidateId) {
                  return { success: false, error: 'Candidate ID is required' };
                }

                const blob = await get(`/recruitment/candidates/${candidateId}/export`, { responseType: 'blob' });

                const sanitized = String(fallbackName || 'Candidate')
                  .replace(/[\\/:*?"<>|]/g, '')
                  .replace(/\s+/g, '_')
                  .replace(/_+/g, '_')
                  .replace(/^_+|_+$/g, '')
                  .slice(0, 80) || 'Candidate';
                const filename = `Candidate_${sanitized}.xlsx`;

                const objectUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = objectUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(objectUrl);

                return { success: true };
              } catch (error) {
                return {
                  success: false,
                  error: error.message || 'Failed to export candidate details'
                };
              }
            },

            // Add new candidate
            addCandidate: async (candidateData) => {
              try {
                const response = await apiClient.post('/recruitment/candidates', candidateData);
                return response;
              } catch (error) {
                return {
                  success: false,
                  responseCode: error.response?.status || 500,
                  responseMessage:
                    error.response?.data?.responseMessage ||
                    error.message ||
                    "Failed to add candidate",
                  error: error.response?.data?.error || error.message,
                  data: null,
                };
              }
            },

            // Update candidate
            updateCandidate: async (id, candidateData) => {
              try {
                const response = await apiClient.put(`/recruitment/candidates/${id}`, candidateData);

                return response;
              } catch (error) {
                return {
                  success: false,
                  responseCode: error.response?.status || 500,
                  responseMessage:
                    error.response?.data?.responseMessage ||
                    error.message ||
                    "Failed to update candidate",
                  error: error.response?.data?.error || error.message,
                  data: null,
                };
              }
            },

              // Delete candidate
              deleteCandidate: async (id, force = false) => {
                try {
                  const url = `/recruitment/candidates/${id}${force ? '?force=true' : ''}`;
                  const response = await apiClient.delete(url);
                  return response;
                } catch (error) {
                  return {
                    success: false,
                    responseCode: error.response?.status || 500,
                    responseMessage:
                      error.response?.data?.responseMessage ||
                      error.message ||
                      'Failed to delete candidate',
                    error: error.response?.data?.error || error.message,
                    data: null,
                  };
                }
              },

  // Move candidate to different stage
  moveCandidate: async (id, newStage, skipValidation = false, reason = '') => {
    try {

      const statusMapping = {
        offer: "offered",
      };
      const normalizedStage =
        statusMapping[newStage] || newStage;

      const response = await apiClient.put(
        `/recruitment/candidates/${id}/move`,
        { status: normalizedStage, skipValidation, reason }
      );

      // The apiClient interceptor returns response.data directly, so response is already the data
      return response;
    } catch (error) {

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage: error.response?.data?.responseMessage || error.message || 'Failed to move candidate. Please try again.',
        error: error.response?.data?.error || error.message,
        data: null,
      };
    }
  },

  // Download candidate resume
  downloadResume: async (id) => {
    try {

      const response = await apiClient.get(`/recruitment/candidates/${id}/resume`, {
        responseType: 'blob'
      });

      // Check if response is actually a blob
      if (!(response instanceof Blob)) {

        throw new Error('Invalid response format');
      }
      // Check if blob is empty
      if (response.size === 0) {
        throw new Error('Empty file received');
      }

      // Create blob URL for download
      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download = `candidate_${id}_resume.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);


      return { success: true };
    } catch (error) {

      // For blob responses, we need to parse the error differently
      if (error.response?.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);

          return {
            success: false,
            responseCode: error.response.status,
            responseMessage:
              errorData.responseMessage ||
              error.message ||
              "Failed to download resume",
            error: errorData.error || error.message,
          };
        } catch (parseError) {

          return {
            success: false,
            responseCode: error.response?.status || 500,
            responseMessage: error.message || "Failed to download resume",
            error: error.message,
          };
        }
      }

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to download resume",
        error: error.response?.data?.error || error.message,
      };
    }
  },

  // Export candidates
  exportCandidates: async (filters = {}) => {
    try {

      // Use direct axios call to avoid interceptor issues
      try {
        const response = await axios.post(`${API_BASE_URL}/recruitment/candidates/export`, filters, {
          responseType: 'blob',
          headers: {
                        'Content-Type': 'application/json',
          }
        });

        // Check if we got a valid blob response
        if (response.data instanceof Blob) {
          return response.data;
        } else {
          throw new Error('Invalid response format from export API');
        }
      } catch (axiosError) {
        // Handle 401 for direct axios calls
        if (axiosError.response?.status === 401) {

          localStorage.removeItem('user_data');

          // Only redirect if not already on login page (prevents reload loop on failed login)
          const currentPath = window.location.pathname;
          if (currentPath !== '/login' && !currentPath.includes('/login')) {

            window.location.replace('/login');
          } else {

          }
        }
        throw axiosError;
      }
    } catch (error) {

      throw {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to export candidates",
        error: error.response?.data?.error || error.message,
      };
    }
  },

  // Bulk actions on candidates
  bulkAction: async (action, candidateIds, data = {}) => {
    try {

      const response = await apiClient.post(
        "/recruitment/candidates/bulk-actions",
        {
          action,
          candidateIds,
          data,
        }
      );

      return response.data;
    } catch (error) {

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          "Failed to perform bulk action",
        error: error.response?.data?.error || error.message,
        data: null,
      };
    }
  },

  // Check movement eligibility
  checkMovementEligibility: async (candidateId, targetStatus) => {
    try {
      const response = await apiClient.get(
        `/recruitment/candidates/${candidateId}/movement-eligibility?targetStatus=${targetStatus}`
      );
      return response.data;
    } catch (error) {
      throw {
        success: false,
        error:
          error.response?.data?.responseMessage ||
          error.response?.data?.message ||
          error.message,
      };
    }
  },

  importCandidates: async (formData) => {
    try {
      const response = await apiClient.post('/recruitment/candidates/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      // The apiClient interceptor returns response.data directly, so response is already the data
      return response;
    } catch (error) {

      // Handle different types of errors
      let errorMessage = 'Failed to import candidates. Please check your file format.';

      if (error.response?.data?.responseMessage) {
        errorMessage = error.response.data.responseMessage;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      } else if (typeof error === 'object' && error !== null) {
        errorMessage = 'Import failed. Please check your file format and try again.';
      }

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage: errorMessage,
        error: error.response?.data?.error || error.message,
        data: null
      };
    }
  },
  getHiredCandidates: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.limit) queryParams.append('limit', params.limit);

      const url = `/recruitment/candidates/hired${queryParams.toString() ? `?${queryParams.toString()}` : ''
        }`;
      const response = await apiClient.get(url);

      // The apiClient interceptor returns response.data directly, so response is already the data
      // Ensure consistent response format
      if (response && response.responseCode) {
        return response;
      } else {
        // Wrap direct response in standard format
        return {
          responseCode: 200,
          responseMessage: 'Hired candidates retrieved successfully',
          data: response,
        };
      }
    } catch (error) {

      return {
        success: false,
        responseCode: error.response?.status || 500,
        responseMessage:
          error.response?.data?.responseMessage ||
          error.message ||
          'Failed to fetch hired candidates',
        error: error.response?.data?.error || error.message,
        data: null,
      };
    }
  },

  /**
   * Bulk upload candidates from parsed CSV data
   * @param {Array} candidates - Array of candidate objects
   * @param {Object} options - Upload options (skipDuplicates, validateOnly)
   */
  bulkUploadCandidates: async (candidates, options = {}) => {
    try {
      const { skipDuplicates = true, validateOnly = false } = options;

      const response = await apiClient.post('/recruitment/candidates/bulk-upload', {
        candidates,
        skipDuplicates,
        validateOnly
      });

      if (response && (response.responseCode === 201 || response.responseCode === 200)) {
        const created = response.data?.created || 0;

        return {
          success: created > 0,
          data: response.data,
          message: response.responseMessage || 'Bulk upload completed',
          error: created > 0
            ? null
            : response.responseMessage || 'No candidates were created'
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to upload candidates',
          data: response.data
        };
      }
    } catch (error) {

      return {
        success: false,
        error: error.response?.data?.responseMessage || error.message || 'Failed to upload candidates',
        data: error.response?.data?.data
      };
    }
  },

  /**
   * Validate bulk upload data without creating candidates
   * @param {Array} candidates - Array of candidate objects to validate
   */
  validateBulkUpload: async (candidates) => {
    try {
      const response = await apiClient.post('/recruitment/candidates/bulk-upload/validate', {
        candidates
      });

      if (response && response.responseCode === 200) {
        return {
          success: true,
          data: response.data,
          isValid: response.data?.isValid,
          errors: response.data?.errors || [],
          duplicates: response.data?.duplicates || []
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to validate candidates',
          data: response.data
        };
      }
    } catch (error) {

      return {
        success: false,
        error: error.response?.data?.responseMessage || error.message || 'Failed to validate candidates'
      };
    }
  },

  /**
   * Download bulk upload CSV template for candidates
   */
  downloadBulkUploadTemplate: async (filename = 'candidate_bulk_upload_template.csv', options = {}) => {
    try {
      const { jobs = [], departments = [] } = options;

      // Get sample job and department from provided lists or use defaults
      const sampleJob = jobs.length > 0 ? jobs[0].label : 'Software Engineer';
      const sampleDept = departments.length > 0 ? departments[0].label : 'Engineering';
      const sampleJob2 = jobs.length > 1 ? jobs[1].label : 'UI Designer';
      const sampleDept2 = departments.length > 1 ? departments[1].label : 'Design';

      const headers = [
        'firstName', 'lastName', 'email', 'phone', 'jobTitle', 'department', 'experience', 'status', 'skills',
        'streetAddress', 'postalCode', 'country', 'state', 'city',
        'currentCompany', 'expectedSalary', 'currentSalary', 'noticePeriod',
        'education', 'university', 'graduationYear',
        'linkedin', 'github', 'portfolio', 'source', 'notes', 'availability'
      ];
      const sampleData = [
        [
          'John', 'Doe', 'john.doe@example.com', '9876543210', sampleJob, sampleDept, '5+', 'applied', 'React;Node.js;MongoDB',
          '123 Green Avenue', '560001', 'India', 'Karnataka', 'Bangalore',
          'Tech Corp', '15,00,000', '12,00,000', '30-days',
          'B.Tech', 'IIT Bombay', '2018',
          'https://linkedin.com/in/johndoe', 'https://github.com/johndoe', 'https://johndoe.me', 'LinkedIn', 'Strong technical skills', 'Available'
        ],
        [
          'Jane', 'Smith', 'jane.smith@example.com', '9876543211', sampleJob2, sampleDept2, '2+', 'shortlisted', 'Figma;Adobe XD;CSS',
          '45 Blue Street', '400001', 'India', 'Maharashtra', 'Mumbai',
          'Creative Solutions', '12,00,000', '10,00,000', '15-days',
          'B.Des', 'NID', '2021',
          'https://linkedin.com/in/janesmith', '', 'https://behance.net/janesmith', 'Referral', 'Good aesthetic sense', 'Not Available'
        ]
      ];

      let csvContent = headers.join(',') + '\n';
      sampleData.forEach(row => {
        csvContent += row.map(cell => `"${String(cell || '').replace(/"/g, '""')}"`).join(',') + '\n';
      });

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {

      return {
        success: false,
        error: error.message || 'Failed to download template'
      };
    }
  },

  /**
   * Parse CSV content to candidate objects
   */
  parseCSV: (csvContent) => {
    try {
      const lines = csvContent.split(/\r?\n/).filter(line => line.trim());
      if (lines.length < 2) {
        return {
          success: false,
          error: 'CSV must contain a header row and at least one data row'
        };
      }

      // Parse header
      const headers = parseCSVLine(lines[0]);

      // Parse data rows
      const candidates = [];
      for (let i = 1; i < lines.length; i++) {
        const values = parseCSVLine(lines[i]);
        if (values.length === 0 || values.every(v => !v.trim())) continue;

        const candidate = {};
        headers.forEach((header, index) => {
          const key = header.trim();
          candidate[key] = values[index]?.trim() || '';
        });
        candidates.push(candidate);
      }

      return { success: true, candidates };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to parse CSV'
      };
    }
  }
};

/**
 * Helper function to parse a CSV line handling quoted values
 */
const parseCSVLine = (line) => {
  const values = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const nextChar = line[i + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      values.push(current);
      current = '';
    } else {
      current += char;
    }
  }

  values.push(current);
  return values;
};

export default candidateService;
